import { type Validation, ValidationError } from '@/models';

export const validationError = (
  validation: Validation,
  value: string,
): ValidationError | undefined => {
  if (!value && validation.required) return ValidationError.EMPTY;
  if (value.length < (validation.minLength || 0))
    return ValidationError.INVALID_LENGTH;
  if (validation.maxLength && value.length > validation.maxLength)
    return ValidationError.INVALID_LENGTH;
  if (validation.pattern && !RegExp(validation.pattern).test(value))
    return ValidationError.INVALID_FORMAT;
};

export const validationMessage = (
  validate: boolean,
  validation: Validation,
  error: ValidationError | undefined,
): string => {
  if (validate) {
    if (error === ValidationError.INVALID_FORMAT)
      return validation.translationPrefix + '_format';
    if (error === ValidationError.INVALID_LENGTH)
      return validation.translationPrefix + '_format';
    if (error === ValidationError.EMPTY)
      return validation.translationPrefix + '_empty';
  }

  return '';
};
